import type { Action } from '@atlassian/react-sweet-state';
import { getIsIssueTypeSubTasksEnabled } from '../../services/is-sub-tasks-enabled';
import type { State } from './types';

export const actions = {
	getIsIssueTypeSubTasksEnabled:
		(): Action<State> =>
		async ({ setState }) => {
			try {
				setState({
					isLoading: true,
				});

				const { enabled } = await getIsIssueTypeSubTasksEnabled();

				setState({
					isLoading: false,
					isEnabled: enabled,
					error: null,
				});
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
			} catch (error: any) {
				setState({
					isLoading: false,
					isEnabled: false,
					error,
				});
			}
		},
} as const;

export type Actions = typeof actions;
